import { Component } from '@theme/component';

/**
 * Handles copying text to clipboard, from an event like a click.
 * Optionally, reveals a success message after copying.
 * @extends {Component}
 */
class CopyToClipboardComponent extends Component {
  #revertTimer;

  copyToClipboard() {
    const copyContent = this.getAttribute('text-to-copy');

    if (!copyContent) return;

    navigator.clipboard.writeText(copyContent);

    const copySuccessMessage = this.refs.copySuccessMessage;
    const srMessage = this.getAttribute('data-sr-message');

    if (copySuccessMessage instanceof Element) {
      if (srMessage) {
        // Keep the message screen-reader-only; populate it so the live region announces.
        copySuccessMessage.textContent = srMessage;
      } else {
        copySuccessMessage.classList.remove('visually-hidden');
      }
    }

    // Visual success state ("Copied", green). Reverts so the user can copy again.
    this.classList.add('is-copied');
    clearTimeout(this.#revertTimer);
    this.#revertTimer = setTimeout(() => {
      this.classList.remove('is-copied');
      if (copySuccessMessage instanceof Element && srMessage) {
        copySuccessMessage.textContent = '';
      }
    }, 2500);
  }
}

if (!customElements.get('copy-to-clipboard-component')) {
  customElements.define('copy-to-clipboard-component', CopyToClipboardComponent);
}
